import './Backdrop.css';

const backdrop = (props) => (
  <div className='backdrop' onClick={props.clickBackdrop}></div>
);

export default backdrop;
